import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import { Button } from "../../../../shared/widgets";

function RenewConfirmationModal(props) {
  const { callBack, showModal } = props;
  return (
    <Dialog
      onClose={() => callBack(null)}
      aria-labelledby="renew-customized-dialog-title"
      open={showModal}
      className="confirmationModal"
    >
      <DialogContent dividers>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>Do you want to edit contract before renewing?</Box>
          <Box className="closeIcon" onClick={() => callBack(null)}>
            <CloseIcon />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          classname="backBtnContainer"
          onClick={() => callBack("renew")}
          buttonText="Renew Contract"
        />
        <Button
          classname="submitBtnContainer"
          onClick={() => callBack("edit")}
          buttonText="Edit Contract"
        />
      </DialogActions>
    </Dialog>
  );
}

RenewConfirmationModal.defaultProps = {
  title: "",
  content: "",
  showModal: false,
  onClick: () => {},
};
RenewConfirmationModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  showModal: PropTypes.bool,
  onClick: PropTypes.func,
};
export default RenewConfirmationModal;
